import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import Terminart from '@/types/Terminart';
import api from '@/services/Api';
import { successSwal, warningSwal } from '@/helper/swals';
import { TerminartenState, RootState } from '@/store/types';

export type TerminartenFilter = { gueltig: string };
export type LoadTerminartenPayload = { filter?: TerminartenFilter; };
export type UpdateTerminartPayload = { terminart: Terminart; filter?: TerminartenFilter; };
export type DeleteTerminartPayload = { terminart: Terminart; filter?: TerminartenFilter; };
export type SetTerminartenDialogs = { edit?: boolean; };
export type SetTerminartenLoaders = { save?: boolean; delete?: boolean; terminarten?: boolean; };

type Context = ActionContext<TerminartenState, RootState>;

export const terminarten: Module<TerminartenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            terminarten: false,
        },
        terminarten: [],
    },
    actions: {
        loadTerminarten({ commit }: Context, payload?: LoadTerminartenPayload): void {
            commit('setLoaders', { terminarten: true });

            const data = {
                ...payload,
            };

            api.post('verwaltung/terminarten/load', data)
                .then(response => commit('setTerminarten', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoaders', { terminarten: false }));
        },
        updateTerminart({ commit, dispatch, rootState }: Context, { terminart, filter }: UpdateTerminartPayload): void {
            commit('setLoaders', { save: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                ...terminart,
            };

            api.post('verwaltung/terminarten/save', data)
                .then(() => {
                    successSwal('Terminarten', 'gespeichert');
                    dispatch('loadTerminarten', { filter });
                    commit('setDialogs', { edit: false });
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { save: false }));
        },
        deleteTerminart({ commit, dispatch, rootState }: Context,
                        { terminart: { terminart }, filter }: DeleteTerminartPayload): void {
            commit('setLoaders', { delete: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
                terminart,
            };

            api.post('verwaltung/terminarten/delete', data)
                .then((response: AxiosResponse) => {
                    if (typeof response.data.body !== 'string') {
                        successSwal('Terminarten', 'gelöscht');
                        dispatch('loadTerminarten', { filter });
                        commit('setDialogs', { edit: false });
                    } else {
                        warningSwal('Löschung', response.data.body ?? 'Terminart ist nicht löschbar.');
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoaders', { delete: false }));
        },
    },
    mutations: {
        setTerminarten(state: TerminartenState, payload: Partial<Terminart>[]): void {
            state.terminarten = payload.map((data) => new Terminart(data));
        },
        setDialogs(state: TerminartenState, dialogs: SetTerminartenDialogs): void {
            state.dialogs = {
                ...state.dialogs,
                ...dialogs,
            };
        },
        setLoaders(state: TerminartenState, loaders: SetTerminartenLoaders): void {
            state.loaders = {
                ...state.loaders,
                ...loaders,
            };
        },
    },
};
